import RequestGenerationContainer from './RequestGenerationContainer'

export default RequestGenerationContainer